import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const InitializeIcon = createSvgIcon(
 <svg
  width="800px"
  height="800px"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
  fill="none">
  <g fill="currentColor">
   <path d="M8 2.5a5.494 5.494 0 00-4.558 2.42.75.75 0 01-1.242-.84 7 7 0 110 7.841.75.75 0 111.242-.841A5.5 5.5 0 108 2.5z" />

   <path d="M7.245 4.695a.75.75 0 00-.05 1.06l1.36 1.495H1.75a.75.75 0 000 1.5h6.805l-1.36 1.495a.75.75 0 001.11 1.01l2.5-2.75a.75.75 0 000-1.01l-2.5-2.75a.75.75 0 00-1.06-.05z" />
  </g>
 </svg>,
 "Initialize"
);
